import React from 'react';

import { Pressable, PressableProps, makeUclComponent } from '@rbilabs/universal-components';
import type { TextStyle } from 'react-native';
import { TypographyProps, withTypography } from 'ucl/components/text/Typography';

const TextContainer = withTypography({ fontFamily: 'heading' });

type Props = PressableProps & {
  _text?: TypographyProps & {
    fontWeight?: TextStyle['fontWeight'];
    letterSpacing?: TextStyle['letterSpacing'] | string;
    lineHeight?: TextStyle['lineHeight'];
    textTransform?: TextStyle['textTransform'] | string;
  };
};

export default makeUclComponent(function UnstyledButton({ children, _text, ...rest }: Props) {
  return (
    <Pressable {...rest}>
      {typeof children === 'string' ? (
        <TextContainer {...((_text || {}) as TypographyProps)}>{children}</TextContainer>
      ) : (
        children
      )}
    </Pressable>
  );
});
